export const mstTestnet = {
  id: 0x11c1,
  name: "MST Testnet",
  // network: "mst-testnet",
  nativeCurrency: {
    name: "tMST",
    symbol: "tMST",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnetrpc.mstblockchain.com"]
      // http: ["http://103.119.171.254:5001/"]
    }
  },
  blockExplorers: {
    default: {
      name: "MST Explorer",
      url: "https://testnet.mstscan.com",
      apiUrl: "https://testnet.mstscan.com"
    }
  },

  testnet: true
};

export const mstMainnet = {
  id: 0x1226,
  name: "MST Mainnet",
  // network: "mst-mainnet",
  nativeCurrency: {
    name: "MSTC",
    symbol: "MSTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://mariorpc.mstblockchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "MST Explorer",
      url: "https://mstscan.com",
      apiUrl: "https://mstscan.com"
    }
  },
  testnet: false
};

export const currentNetwork =
  process.env.REACT_APP_NETWORK === "testnet" ? mstTestnet : mstMainnet;
